const local = {
  API_ROOT: 'https://local-api.avatarnutrition.com',
  BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
  FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
  HOME_ROOT: 'http://localhost:3000',
  SCANDIT_KEY: "AV8+GzwGHfr/Bw8f6DuaRYgICOjoAmi6z050J6pFnHMmfTq9s0VQYkVsYNO4fjrZ/mhaFhhfBfuuS4CvQndKQ2Ens2hOdLfam33mM1kehCTxZkHqqmOwEqFdYZD9Rj2eZCuH6ecz3ySPVsMAV2WHaq9+wO0IerUmhkbBaux1HWosD6WOCwKbsy0nnalUL0lSwvoGFWuMpNY03NYJ8S3FwBN6AOylG3ZHXB0tlfUGE8Xa4vlt7YAexzmFIWNG6itnk42DtFPYMZJh/iQMwP5M9fivE4nzSecmoLUR02LHboQMhMHrgVgrDZcofjdCCmIs/K9XNp14aNGOc9Uke6w8fDATzmPBGicVaVM2sCbEh4k17KKEgwVANn5saV0zrixHxlbcaMwU/rBZPbGdodZaEP/BreE0P4iD5jSm15TADorBaYFpQKAdpKoevnFRQFHkhlX8Y0+iq+N9S6Df/BoEMLrVsI29A/n4TZ/0ekYWMZxdPhBCz5XcGbx42Uj1PMT5IdqKTOkLJY1omlgUEKUzB2QnmpzMbBXXazRy6o8jQ7vy73XT34gwF4fJhyNRiTYD9r8S5I1jSNqK7Xpc00llXp000LwFw83S4Bb/IeQwW24q86kiDt1UypsqSACgBe6FIb8e9B4WlgAeO+LKXmLRCICqRCCRo7DlVqswOkU5ESyVsX/magXDDn/ZecbugwZG/1CAobWQcEr0hfYyNS4lYmUhCU5p8iilvOBRfoEVpwP0lypl0RRkshEn16+4KH36bFZWonXJxdSqo9YcOFho4d+3t5uV/r3RJYP9gQcNBKCH/b8/zAyjp/kweaoPdJSLpt3+TFXwYqn1LF9iWzFBPYfhyEAybyfXU5REwcg=",
  WP_ROOT: 'https://uat-posts.avatarnutrition.com/index.php/wp-json/wp/v2',
  APP_ROOT: 'http://localhost:3000',
  STREAMCHAT: {
    userPrefix: 'local-',
    portalUserPrefix: 'local-avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }
 
 const dev = {
   API_ROOT: 'https://dev-api.avatarnutrition.com',
   BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
   FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
   HOME_ROOT: 'http://dev-www.avatarnutrition.com',
   SCANDIT_KEY: "AV8+GzwGHfr/Bw8f6DuaRYgICOjoAmi6z050J6pFnHMmfTq9s0VQYkVsYNO4fjrZ/mhaFhhfBfuuS4CvQndKQ2Ens2hOdLfam33mM1kehCTxZkHqqmOwEqFdYZD9Rj2eZCuH6ecz3ySPVsMAV2WHaq9+wO0IerUmhkbBaux1HWosD6WOCwKbsy0nnalUL0lSwvoGFWuMpNY03NYJ8S3FwBN6AOylG3ZHXB0tlfUGE8Xa4vlt7YAexzmFIWNG6itnk42DtFPYMZJh/iQMwP5M9fivE4nzSecmoLUR02LHboQMhMHrgVgrDZcofjdCCmIs/K9XNp14aNGOc9Uke6w8fDATzmPBGicVaVM2sCbEh4k17KKEgwVANn5saV0zrixHxlbcaMwU/rBZPbGdodZaEP/BreE0P4iD5jSm15TADorBaYFpQKAdpKoevnFRQFHkhlX8Y0+iq+N9S6Df/BoEMLrVsI29A/n4TZ/0ekYWMZxdPhBCz5XcGbx42Uj1PMT5IdqKTOkLJY1omlgUEKUzB2QnmpzMbBXXazRy6o8jQ7vy73XT34gwF4fJhyNRiTYD9r8S5I1jSNqK7Xpc00llXp000LwFw83S4Bb/IeQwW24q86kiDt1UypsqSACgBe6FIb8e9B4WlgAeO+LKXmLRCICqRCCRo7DlVqswOkU5ESyVsX/magXDDn/ZecbugwZG/1CAobWQcEr0hfYyNS4lYmUhCU5p8iilvOBRfoEVpwP0lypl0RRkshEn16+4KH36bFZWonXJxdSqo9YcOFho4d+3t5uV/r3RJYP9gQcNBKCH/b8/zAyjp/kweaoPdJSLpt3+TFXwYqn1LF9iWzFBPYfhyEAybyfXU5REwcg=",
   WP_ROOT: 'https://uat-posts.avatarnutrition.com/index.php/wp-json/wp/v2',  
   APP_ROOT: 'https://dev-app.avatarnutrition.com',
   STREAMCHAT: {
    userPrefix: 'dev-',
    portalUserPrefix: 'dev-avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }
 
 const uat = {
   API_ROOT: 'https://uat-api.avatarnutrition.com',
   BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
   FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
   HOME_ROOT: 'http://uat-www.avatarnutrition.com',
   SCANDIT_KEY: "AV8+GzwGHfr/Bw8f6DuaRYgICOjoAmi6z050J6pFnHMmfTq9s0VQYkVsYNO4fjrZ/mhaFhhfBfuuS4CvQndKQ2Ens2hOdLfam33mM1kehCTxZkHqqmOwEqFdYZD9Rj2eZCuH6ecz3ySPVsMAV2WHaq9+wO0IerUmhkbBaux1HWosD6WOCwKbsy0nnalUL0lSwvoGFWuMpNY03NYJ8S3FwBN6AOylG3ZHXB0tlfUGE8Xa4vlt7YAexzmFIWNG6itnk42DtFPYMZJh/iQMwP5M9fivE4nzSecmoLUR02LHboQMhMHrgVgrDZcofjdCCmIs/K9XNp14aNGOc9Uke6w8fDATzmPBGicVaVM2sCbEh4k17KKEgwVANn5saV0zrixHxlbcaMwU/rBZPbGdodZaEP/BreE0P4iD5jSm15TADorBaYFpQKAdpKoevnFRQFHkhlX8Y0+iq+N9S6Df/BoEMLrVsI29A/n4TZ/0ekYWMZxdPhBCz5XcGbx42Uj1PMT5IdqKTOkLJY1omlgUEKUzB2QnmpzMbBXXazRy6o8jQ7vy73XT34gwF4fJhyNRiTYD9r8S5I1jSNqK7Xpc00llXp000LwFw83S4Bb/IeQwW24q86kiDt1UypsqSACgBe6FIb8e9B4WlgAeO+LKXmLRCICqRCCRo7DlVqswOkU5ESyVsX/magXDDn/ZecbugwZG/1CAobWQcEr0hfYyNS4lYmUhCU5p8iilvOBRfoEVpwP0lypl0RRkshEn16+4KH36bFZWonXJxdSqo9YcOFho4d+3t5uV/r3RJYP9gQcNBKCH/b8/zAyjp/kweaoPdJSLpt3+TFXwYqn1LF9iWzFBPYfhyEAybyfXU5REwcg=",
   WP_ROOT: 'https://uat-posts.avatarnutrition.com/index.php/wp-json/wp/v2',
   APP_ROOT: 'https://uat-app.avatarnutrition.com',
   STREAMCHAT: {
    userPrefix: 'uat-',
    portalUserPrefix: 'uat-avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }
 
 const prod = {
   API_ROOT: 'https://api.avatarnutrition.com',
   BRAINTREE_DROPIN: 'production_7jsf8j4b_tm4gmb6qfhhnby8y',
   FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
   HOME_ROOT: 'https://www.avatarnutrition.com',
   SCANDIT_KEY: "Ae2c5NCBRBgaCFo1dA+WGKcO5+QNGD3Fq0+gWPVDgymNb+FfQV6ygnBUtXQ2Ysk4YXeGaTwgpPDeRlHw8G/NB1lZDf7mfL5hiWtUXIVwFcH5fqOlIEUQASZnNrQ4c/7lEztD2CA/ECZmmRCMTlzJ4M7ZyorAF+g1DnkuFg3tGW+PpIgtQYNXIsKSeoRbZUbKywRCEO3aHjw9YfMaM2yfIpQYSKteiu8W3dTmnsZE5pS22pnp1wqSjhRXFL3RqWAMFhm7ONDvMajB700271K5Hs4JpVomGjDFFoemv1zHmdCRjh8zq4II3uFcysbfVbY+8QkfqQ1dK4286ehJHat2x6j09tWJA5vpO5PBmpazdUUCj59E+gjgfndnZsk3RcNbcucqdOETkAJYufgfyl4Goh+DyZsvNyx7WaOxuPrjF306vlV0cgQko8c8/lcGsErycheM/R79y5mVatONE/k6oHDsJRGgM69YwQQGQ+nrX86kRu1/Yra+Yo8cmyj+jzcwpI7vR86/dAOArD4N9ze9K1kSuw1BlMEOS9L4cn/rRxVzwqAEY1mWEVhbIzg5MHmaKIH04anXIH2ddLnxOqNkQMwNDj6TKJbBjKOWQBYmHs3RUWudNh3LiE1gaUAEFMq0pxiF9QzaWxqX9xybDo6caUKt8V7mtQLShheqb2pYp013DXPKmY1+IRlql/1+fbCXCbS9wGr8JJkb8baGnDD6wtfV1wdzp0RK03D4l53NDdtxOREPejTiT5e8JoEYeHxEkZsTse9Gpcwn47rmZpzBDloa6dXlQxMP1tUsgviqtjxQ5LFBLezfphA=",
   WP_ROOT: 'https://posts.avatarnutrition.com/index.php/wp-json/wp/v2',  
   APP_ROOT: 'https://app.avatarnutrition.com',
   STREAMCHAT: {
    userPrefix: '',
    portalUserPrefix: 'avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }

const config = (function(env) {
  switch(env) {
    case 'prod':
        return prod;
    case 'uat': 
        return uat;
    case 'dev': 
        return dev;
    default: 
        return local;
  }
})(process.env.REACT_APP_STAGE)

export default {
  ...config 
}
